import Newsfeed from './Newsfeed';
export default Newsfeed;
